// src/pages/home/components/ContactSection.tsx
import React from "react";

type State = { ok: boolean; error?: string } | null;

function ContactSection() {
  const [state, setState] = React.useState<State>(null);
  const [sending, setSending] = React.useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setState(null);
    setSending(true);

    try {
      const form = e.currentTarget;
      const data = new FormData(form);

      // ✅ endpoint local OVH
      const response = await fetch("/api/contact.php", {
        method: "POST",
        body: data,
      });

      const json = (await response.json().catch(() => null)) as State;
      if (!response.ok || !json?.ok) throw new Error(json?.error || "Erreur serveur");

      setState({ ok: true });
      form.reset();
    } catch (err: any) {
      setState({ ok: false, error: err?.message || "Envoi impossible" });
    } finally {
      setSending(false);
    }
  }

  return (
    <section className="py-16 bg-blue-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">Un message ?</h2>
          <p className="text-gray-600 mb-6">
            Posez vos questions, on vous répond rapidement.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4" id="contact-form">
            {/* Honeypot anti-bot */}
            <input type="text" name="website" className="hidden" tabIndex={-1} autoComplete="off" />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                name="name"
                required
                placeholder="Votre nom"
                className="w-full rounded-lg border border-gray-300 p-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
              />
              <input
                type="email"
                name="email"
                required
                placeholder="Votre e-mail"
                className="w-full rounded-lg border border-gray-300 p-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
              />
            </div>

            <textarea
              name="message"
              required
              placeholder="Votre message…"
              className="w-full rounded-lg border border-gray-300 p-3 h-36 resize-y focus:outline-none focus:ring-2 focus:ring-blue-600"
            />

            <button
              type="submit"
              disabled={sending}
              className={`px-6 py-3 rounded-lg text-white transition-colors ${
                sending ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              {sending ? "Envoi…" : "Envoyer"}
            </button>

            <div aria-live="polite">
              {state?.ok && <p className="mt-2 text-green-600 text-sm">Message envoyé ✅</p>}
              {state?.ok === false && (
                <p className="mt-2 text-red-600 text-sm">
                  Oups, échec de l’envoi. {state.error ? `(${state.error})` : "Réessayez plus tard."}
                </p>
              )}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
export { ContactSection };
